import type { RouteRecordRaw } from 'vue-router'

import { toWebviewRouteName } from './utils'

function recursivelyWebviewifyRoute(route: RouteRecordRaw): RouteRecordRaw {
  /**
   * If the route has children routes, then we don't need to modify the current route
   * but we modify its children recursively
   */
  if (route.children) {
    const children = route.children.map(recursivelyWebviewifyRoute)

    return {
      ...route,
      children,
    }
  }

  return {
    ...route,
    name: toWebviewRouteName(String(route.name)),
    meta: {
      ...(route.meta || {}),
      isWebview: true,
    },
  }
}
export function generateWebviewRoutes(
  routes: RouteRecordRaw[],
): RouteRecordRaw[] {
  const webviewRoutes = routes.map(recursivelyWebviewifyRoute)

  return [
    {
      path: 'webview',
      component: () =>
        import(
          '@backmarket/nuxt-layer-base/components/RouteRecordWithChildrenOnly/RouteRecordWithChildrenOnly.vue'
        ),
      meta: { layout: 'webview-default' },
      children: webviewRoutes,
    },
  ]
}
